"use client";

import { motion, AnimatePresence } from "framer-motion";
import { Wrench } from "lucide-react";
import { useEffect, useState } from "react";

interface ScreenLoaderProps {
  isVisible: boolean;
}

export function ScreenLoader({ isVisible }: ScreenLoaderProps) {
  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          className="fixed inset-0 z-[100] flex items-center justify-center bg-white dark:bg-black"
        >
          <div className="flex flex-col items-center gap-6">
            <motion.div
              animate={{
                rotate: 360,
                scale: [1, 1.1, 1],
              }}
              transition={{
                rotate: { duration: 2, repeat: Infinity, ease: "linear" },
                scale: { duration: 1.5, repeat: Infinity, ease: "easeInOut" }
              }}
              className="flex h-20 w-20 items-center justify-center rounded-full bg-orange-600 shadow-[0_0_30px_rgba(249,115,22,0.4)] dark:bg-blue-600 dark:shadow-[0_0_30px_rgba(37,99,235,0.4)]"
            >
              <Wrench className="h-10 w-10 text-white" />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="flex flex-col items-center gap-2"
            >
              <span className="text-xl font-bold tracking-widest text-zinc-900 dark:text-white uppercase">
                Automatyka CNC
              </span>
              <div className="h-1 w-48 overflow-hidden rounded-full bg-zinc-100 dark:bg-zinc-800">
                <motion.div
                  initial={{ x: "-100%" }}
                  animate={{ x: "100%" }}
                  transition={{
                    duration: 1.5,
                    repeat: Infinity,
                    ease: "easeInOut"
                  }}
                  className="h-full w-full bg-gradient-to-r from-transparent via-orange-500 to-transparent dark:via-blue-500"
                />
              </div>
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
